import type { ReferralBinding } from '@/types/referrals';

/** 显式登录目标优先于落地页默认入口，并限制为同源路径。 */
export function resolveLoginDestination(explicitRedirect: string | null, surfaceRedirect: string | undefined, origin: string): string {
  const candidate = explicitRedirect || surfaceRedirect;
  if (!candidate?.startsWith('/') || candidate.startsWith('//')) return '/explore';
  try {
    const target = new URL(candidate, origin);
    return target.origin === origin ? `${target.pathname}${target.search}${target.hash}` : '/explore';
  } catch { return '/explore'; }
}

/** 归因入口随链接传递，复制邀请码则只带 code，不伪造点击来源。 */
export function buildReferralShareLink(origin: string, code: string, source: string): string {
  if (!origin || !code) return '';
  const params = new URLSearchParams({ ref: code, source_channel: source, campaign_key: 'creator_referral' });
  return `${origin}/login?${params.toString()}`;
}

export function getReferralResetCountdown(resetAt: string | null | undefined, now: number) {
  const end = resetAt ? Date.parse(resetAt) : NaN;
  if (!Number.isFinite(end)) return null;
  const minutes = Math.max(0, Math.ceil((end - now) / 60_000));
  return { days: Math.floor(minutes / 1440), hours: Math.floor((minutes % 1440) / 60), minutes: minutes % 60, expired: end <= now };
}

export type ReferralRewardDelivery = 'granted' | 'pending' | 'held' | 'unavailable';

/** 绑定只证明归因成立，到账必须以服务端记账确认字段为准。 */
export function getReferralRewardDelivery(binding: ReferralBinding): ReferralRewardDelivery {
  const status = binding.invitee_reward_status;
  if (status === 'rejected' || status === 'reversed' || status === 'reversing') return 'unavailable';
  if (binding.bound && binding.invitee_reward_granted === true) return 'granted';
  if (status === 'held') return 'held';
  return 'pending';
}
